import $ from "jquery";
import "slick-carousel";

export const Homepage = function () {
	if (!($("#homepage").length > 0)) return false;

	const $carousel = $(".js-carousel-slide");

	if ($carousel.length) {
		$carousel.each(function () {
			const $this = $(this);
			const $slides = $this.find(".js-carousel-item");
			const slidesToShow = $slides.length > 1 ? 2 : 1;
			const slidesToScroll = $slides.length > 1 ? 1 : 1;

			$this.slick({
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: slidesToShow,
				slidesToScroll: slidesToScroll,
				arrows: false,
				adaptiveHeight: true,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			});
		});
	}




	// if ($carousel.length) {
	// 	$carousel.each(function () {
	// 		const $this = $(this);
		

	// 		$this.slick({
	// 			infinite: true,
	// 			slidesToShow: 3,
	// 			slidesToScroll: 3
				
	// 		});
	// 	});
	// }

	const $elms = {
		btnPlayVideo: $(".js-play-video"),
		btnReplayVideo: $(".js-replay-video"),
		navigation: $(".js-navigation"),
		videoElement: $("#hero-video").get(0),
		videoWrapper: $(".video"),
		thumbnailCanvas: $("#video-thumbnail").get(0)
	};


	const generateThumbnail = function() {
        const video = $elms.videoElement;
        const canvas = $elms.thumbnailCanvas;
        
        if (video && canvas) {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        }
    };

	$($elms.videoElement).on('loadedmetadata', function() {
        this.currentTime = 0.1;
    });

	$($elms.videoElement).on('seeked', function() {
        generateThumbnail();
    });

	const onBtnPlayVideoClick = function () {
        const videoElement = $("#hero-video").get(0);
        const videoWrapper = $(".video");
        if (videoElement && videoElement.paused) {
            videoElement.play();
            videoElement.muted = false;
            videoWrapper.addClass("is-playing").removeClass("is-finished is-paused");
            $("#video-thumbnail").hide();
        } else {
            videoElement.pause();
            videoWrapper.removeClass("is-playing");
        }
    };


	const onBtnPauseVideoClick = function () {
		const videoElement = $("#hero-video").get(0);
		const videoWrapper = $(".video");
		if (videoElement) {
			videoElement.pause();
			videoWrapper.addClass("is-paused").removeClass("is-playing");
			
		}
	};

	

	$($elms.btnPlayVideo).on("click", function (e) {
		e.preventDefault();
		onBtnPlayVideoClick();
	});

	$($elms.btnReplayVideo).on("click", function (e) {
		e.preventDefault();
		onBtnPlayVideoClick();
	});

	$($elms.videoElement).on("ended", function () {
		$($elms.videoWrapper).addClass("is-finished");
	});
	
	$($elms.videoElement).on("click", function() {
		if ($($elms.videoWrapper).hasClass("is-playing")) {
			onBtnPauseVideoClick();
		} 
	})

	$($elms.navigation).on("click", function () {
		const url = $(this).attr("data-url");
		if (url) {
			window.location.href = url;
		}
	});

	$($elms.videoElement).on("ended", function () {
        $($elms.videoWrapper).addClass("is-finished");
        $("#video-thumbnail").show();
    });
};
